<template>
  <div>
    <b-columns is-multiline>
      <b-column
        class="is-half-desktop"
        v-for="(symptom, idx) in agentSymptoms"
        :key="idx"
      >
        <agent-symptom-card
          :symptom="symptom.symptom"
          :treatments="symptom.treatments"
        />
      </b-column>
    </b-columns>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AgentSymptomCard from './AgentSymptomCard'

export default {
  components: {
    AgentSymptomCard
  },
  computed: {
    ...mapGetters(['agentSymptoms'])
  }
}
</script>
